import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Mutation } from '@apollo/client/react/components';
import { Link } from 'react-router-dom';
import { Route } from 'react-router';
import Styled from 'styled';

import SVGIconView from 'lib/images/svg-icon-view';

import IconMember from 'four-nets/icons/svg/icon_members.svg';
import ImageView from 'lib/images/image-view';

import IconFeed from 'four-nets/icons/svg/icon_feed.svg';
import IconAddToGroup from 'four-nets/icons/svg/icon_add-to-group.svg';
import TextShortener from 'four-nets/ui-v2/text-shortener/text-shortener';
import { GroupTileFragment } from 'four-nets/photoblog/groups/groups/group.graphql';
import { AuthOrigin } from 'four-nets/user/auth/auth-ga-events';

import joinGroupMutation, { JoinGroupMutation, JoinGroupMutationVariables } from './mutation.graphql';
import defaultStyles from './group.scss';

export interface Props extends GroupTileFragment {
    styles: typeof defaultStyles;
}

class Group extends React.PureComponent<Props> {
    static contextTypes = {
        authCheck: PropTypes.func,
    };
    render() {
        const { styles } = this.props;
        return (
            <div className={styles.group}>
                <Link to={this.props.href} className={styles.link}>
                    <div className={styles.image}>
                        {this.props.coverPhoto ? (
                            <FormattedMessage id='GROUP_COVER_PHOTO'>
                                {msg => (
                                    <ImageView
                                        aspectFill={true}
                                        srcSet={this.props.coverPhoto!.srcset!}
                                        src={this.props.coverPhoto!.src}
                                        sizes={{ xs: 200 }}
                                        alt={`${this.props.name} - ${msg}`}
                                        linkify={false}
                                    />
                                )}
                            </FormattedMessage>
                        ) : null}
                    </div>
                    <h3 className={styles.groupName}>{this.props.name}</h3>
                </Link>
                <div className={styles.groupInfo}>
                    <p className={styles.description}>
                        <TextShortener
                            text={this.props.description ? this.props.description : ''}
                            words={30}
                            textLength={120}
                        />
                    </p>
                    <div className={styles.groupStats}>
                        <div>
                            <SVGIconView className={styles.statImage} src={IconMember} />
                            <FormattedMessage
                                id='FORUM_%(num)s_PRIVATE_THREAD_MEMBERS'
                                values={{ num: this.props.membersCount }}
                            />
                        </div>
                        <div className={styles.statMessages}>
                            <SVGIconView className={styles.statImage} src={IconFeed} />
                            <FormattedMessage
                                id='%(number)s_FORUM_MESSAGES'
                                values={{ number: this.props.postsCount }}
                            />
                        </div>
                    </div>
                    {this.props.isJoinedByViewer ? (
                        <form action={this.props.href}>
                            <button className={styles.enterGroupButton}>
                                <FormattedMessage id='ENTER_GROUP' />
                            </button>
                        </form>
                    ) : (
                        <Route>
                            {({ history }) => (
                                <Mutation<JoinGroupMutation, JoinGroupMutationVariables> mutation={joinGroupMutation}>
                                    {joinGroup => (
                                        <button
                                            className={styles.addToGroupButton}
                                            onClick={() =>
                                                this.context.authCheck(() => {
                                                    return joinGroup({
                                                        variables: {
                                                            input: {
                                                                id: this.props.id,
                                                            },
                                                        },
                                                    }).then(() => {
                                                        history.push(this.props.href);
                                                    });
                                                }, AuthOrigin.JoinGroup)
                                            }
                                        >
                                            <SVGIconView className={styles.addToGroupImage} src={IconAddToGroup} />
                                            <FormattedMessage id='GROUPS_ADD_TO_GROUP' />
                                        </button>
                                    )}
                                </Mutation>
                            )}
                        </Route>
                    )}
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(Group);
